import { useNavigate } from "react-router-dom";
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { getAllListUsers } from "../../../redux/booking/action";
import React, { useState, useEffect } from "react";
import swal from "sweetalert";
import { useFormik } from "formik";
import Spinner from "../../Layouts/Spinner";
import {
  addClientValidation,
  addIndiClientValidation,
} from "../../Constant/constant";
import PhoneInput from "react-phone-input-2";
import ReactSelect from "react-select";
import {
  addClient,
  clientsDataList,
  userCategoriesList,
} from "../../../redux/user/action";

export default function AddClient({ id, modal, setModal }) {
  const dispatch = useDispatch();

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [singleClient, setSingleClient] = useState(false);
  const categoryList = useSelector(
    (state) => state?.reusableSlice?.categoryList
  );

  const proOptions = categoryList?.categories?.map((item) => ({
    value: item?.id,
    label: item?.title,
  }));

  useEffect(() => {
    dispatch(userCategoriesList({ type: 2 }));
  }, [dispatch]);

  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      parent_id: Number(id),
      first_name: "",
      // last_name: "",
      email_id: "",
      client_type: "",
      company_registration_number: "",
      company_vat_number: "",
      mobile_number: "",
      country_code: "",
      address: "",
      category_id: "",
      street_name: "",
      building_number: "",
      city: "",
      postal_code: "",
      district: "",
      client_send_mail: 0,
    },
    validationSchema: singleClient
      ? addIndiClientValidation
      : addClientValidation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleChange = (selected) => {
    setSelectedOptions(selected);
    const categoryIds = selected.map((option) => option.value).join(",");
    formik.setFieldValue("category_id", categoryIds);
  };

  const handleSubmit = async (values) => {
    const location_address = [
      values.street_name,
      values.building_number,
      values.city,
      values.postal_code,
      values.district,
    ]
      .filter(Boolean)
      .join(", ");
    const data = {
      ...values,
      parent_id: id,
      address: location_address,
      building_number: String(values.building_number),
    };
    dispatch(addClient(data, setLoading, setModal, modal))
      .then((res) => {
        if (res.data.status) {
          dispatch(clientsDataList({ parent_id: id }));
        }
      })
      .catch((e) => console.log(e.message, "the error in add client"));
  };

  const handelContryCode = (value, data) => {
    formik.setFieldValue(
      "mobile_number",
      `${value.slice(data.dialCode.length)}`
    );
    formik.setFieldValue("country_code", `+${data.dialCode}`);
  };

  const handleSwitchChange = (value) => {
    formik.setFieldValue("client_send_mail", value ? 1 : 0);
  };

  const handleClientTypeChange = (e) => {
    const gender = e.target.value;
    setSingleClient(Number(gender) === 1 ? false : true);
    formik.setFieldValue("client_type", Number(gender));
  };

  return (
    <>
      <Modal
        className="filter-modal width-modal-dialog"
        isOpen={modal}
        toggle={() => setModal((state) => !state)}
        centered
      >
        <ModalHeader toggle={() => setModal((state) => !state)}>
          Add Client
        </ModalHeader>
        <div className=" category-wrapper">
          <form onSubmit={formik.handleSubmit}>
            <div className="row ">
              <div className="col-md-4 form-group">
                <label>Company Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter company name"
                  name="first_name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.first_name}
                />
                {formik.touched.first_name && formik.errors.first_name ? (
                  <div className="error">{formik.errors.first_name}</div>
                ) : null}
              </div>
              {/* <div className="col-md-4 form-group">
                <label>Last Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter last name"
                  name="last_name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.last_name}
                />
                {formik.touched.last_name && formik.errors.last_name ? (
                  <div className="error">{formik.errors.last_name}</div>
                ) : null}
              </div> */}
              <div className="col-md-4 form-group">
                <label>Email id</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter email_id"
                  name="email_id"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email_id}
                />
                {formik.touched.email_id && formik.errors.email_id ? (
                  <div className="error">{formik.errors.email_id}</div>
                ) : null}
              </div>
              <div className="col-md-4 form-group">
                <label htmlFor="email">Mobile No.</label>
                <PhoneInput
                  country={"sa"}
                  value={
                    formik?.values.country_code
                      ? `${formik.values.country_code}${formik.values.mobile_number}`
                      : `''`
                  }
                  onChange={(phone, data) => handelContryCode(phone, data)}
                />
                {formik.touched.mobile_number && formik.errors.mobile_number ? (
                  <div className="error">{formik.errors.mobile_number}</div>
                ) : null}
              </div>
              <div className="col-md-4 form-group">
                <label>Company Registration Number</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter registration number"
                  name="company_registration_number"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.company_registration_number}
                />
                {formik.touched.company_registration_number &&
                formik.errors.company_registration_number ? (
                  <div className="error">
                    {formik.errors.company_registration_number}
                  </div>
                ) : null}
              </div>
              <div className="col-md-4 form-group">
                <label>Company Vat Number</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter vat number"
                  name="company_vat_number"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.company_vat_number}
                />
                {formik.touched.company_vat_number &&
                formik.errors.company_vat_number ? (
                  <div className="error">
                    {formik.errors.company_vat_number}
                  </div>
                ) : null}
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="invoice_type">Category id</label>
                <ReactSelect
                  isMulti
                  value={selectedOptions}
                  onChange={handleChange}
                  options={proOptions}
                />
                {formik.touched.category_id && formik.errors.category_id ? (
                  <div className="error">{formik.errors.category_id}</div>
                ) : null}
              </div>
              <div className="form-group col-md-4">
                <label htmlFor="invoice_type">Client Type</label>
                <select
                  id="client_type"
                  name="client_type"
                  className="form-control"
                  onChange={handleClientTypeChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.client_type}
                >
                  <option value="">Select Client type</option>
                  <option value="1">Business</option>
                  <option value="2">Individual</option>
                </select>
                {formik.touched.client_type && formik.errors.client_type ? (
                  <div className="error">{formik.errors.client_type}</div>
                ) : null}
              </div>
              <div className="col-md-4 form-group">
                <label>Street Name</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter street name"
                  name="street_name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.street_name}
                />
                {formik.touched.street_name && formik.errors.street_name ? (
                  <div className="error">{formik.errors.street_name}</div>
                ) : null}
              </div>
              <div className="col-md-4 form-group">
                <label>Building Number</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter building number"
                  name="building_number"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.building_number}
                />
                {formik.touched.building_number &&
                formik.errors.building_number ? (
                  <div className="error">{formik.errors.building_number}</div>
                ) : null}
              </div>
              <div className="col-md-4 form-group">
                <label>City</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter city"
                  name="city"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.city}
                />
                {formik.touched.city && formik.errors.city ? (
                  <div className="error">{formik.errors.city}</div>
                ) : null}
              </div>
              <div className="col-md-4 form-group">
                <label>Postal Code</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter postal code"
                  name="postal_code"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.postal_code}
                />
                {formik.touched.postal_code && formik.errors.postal_code ? (
                  <div className="error">{formik.errors.postal_code}</div>
                ) : null}
              </div>

              <div className="col-md-4 form-group">
                <label>District</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter district"
                  name="district"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.district}
                />
                {formik.touched.district && formik.errors.district ? (
                  <div className="error">{formik.errors.district}</div>
                ) : null}
              </div>
              <div className="col-md-12">
                <h5>Send alerts on email</h5>
                <div className="col-md-12 form-group d-flex ">
                  <p>
                    <strong>Customer Notifications</strong> :{" "}
                    <span>
                      When enabled, your customers will receive invoices and
                      purchase notes by email.
                    </span>{" "}
                  </p>
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={formik.values.client_send_mail}
                      onChange={(e) => handleSwitchChange(e.target.checked)}
                    />
                    <span className="slider round"></span>
                  </label>
                </div>
              </div>
            </div>
            <div
              className="d-flex align-items-center justify-content-center mt-3  "
              style={{ columnGap: "20px" }}
            >
              {/* <button  toggle={() => setModal((state) => !state)} className='submit-btn  '   style={{width:'max-content'}} >
                   Back
                </button> */}
              <button
                className="submit-btn   "
                style={{ width: "max-content" }}
                type="submit"
              >
                {!loading ? "Submit" : <Spinner />}
              </button>
            </div>
          </form>
        </div>
        <ModalBody></ModalBody>

        <ModalFooter className="justify-content-center"></ModalFooter>
      </Modal>
    </>
  );
}
